import { Injectable } from '@angular/core';
import { Platform } from "ionic-angular";
import {a} from "@angular/core/src/render3";

/*
  Generated class for the PrinterServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PrinterServiceProvider {
  private win: any;
  private defaultTimeout: Number = 100;

  constructor(private platform: Platform) {
    this.win = window;
    this.platform.ready().then(() => {
      if (this.win.cordova && !this.win.DatecsPrinter) {
        console.warn(
          "DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'"
        );
      }
    });
  }

  listBluetoothDevices() {
    return new Promise<any>((resolve, reject) => {
      this.win.DatecsPrinter.listBluetoothDevices(
        success => resolve(success),
        error => reject(error)
      );
    });
  }

  connect(deviceAddress: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.win.DatecsPrinter.connect(
        deviceAddress,
        success => resolve(success),
        error => reject(error)
      ),
        this.defaultTimeout;
    });
  }

  disconnect(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.win.DatecsPrinter.disconnect(
        success => resolve(success),
        error => reject(error)
      );
    });
  }

  feedPaper(lines: Number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.win.DatecsPrinter.feedPaper(
        lines,
        success => resolve(success),
        error => reject(error)
      );
    });
  }

  printText(text: string, charset: string = "ISO-8859-1") {
    this.win.DatecsPrinter.printText(
      text,
      charset,
      () => {},
      () => {}
    );
  }

  printTextOld(text: string, charset: string = "ISO-8859-1"): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.win.DatecsPrinter.printText(
        text,
        charset,
        success => resolve(success),
        error => reject(error)
      );
    });
  }

  printMyBarcode() {
    this.win.DatecsPrinter.printBarcode(
      75, //here goes the barcode type code
      "13132498746313210584982011487", //your barcode data
      function() {
        alert("success!");
      },
      function(error) {
        alert(JSON.stringify(error));
      }
    );
  }

  printImage(text, logoId) {
      let image = new Image();
      image.setAttribute('crossorigin', 'anonymous');
      image.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.height = 150;
        canvas.width = 150;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0);
        const imageData = canvas
          .toDataURL("image/jpeg")
          .replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype
        this.win.DatecsPrinter.printImage(
          imageData, //base64
          canvas.width,
          canvas.height,
          0,
          () => {
             this.printText(text)
          },
          error => {
            alert('Please check your connection');
            //alert(JSON.stringify(error));
          }
        );
      };
      image.src = `https://www.readycash.com.ng:6443/rc/images/${logoId}.png`;
  }

}



// WEBPACK FOOTER //
// ./src/providers/printer-service/printer-service.ts